<span
  data-test="Ck7bQx2n"
  class="badge badge_sm text-nowrap"
  [class.badge_blue]="kind === 'client-user'"
  [class.badge_gray]="kind === 'contact'"
  [attr.title]="kind === 'client-user' ? 'Has a BeeKing login' : 'No login'"
>
  <svg data-test="Rv3mLp8w" width="8px" height="8px">
    <use
      [attr.xlink:href]="kind === 'client-user' ? '#icon-users' : '#icon-person'"
    ></use>
  </svg>
  {{ kind === 'client-user' ? 'Client user' : 'Contact' }}
</span>
